import { render, staticRenderFns } from "./import-history.vue?vue&type=template&id=23af72f9&"
import script from "./import-history.vue?vue&type=script&lang=js&"
export * from "./import-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports